import React from 'react'
import '../Styles/DeafCampPage2.scss';
import speakerImage1 from "../Images/140308_Stump,_Levi_U3.png";
import speakerImage2 from "../Images/140311_Stump,_Grant_U3.png";
import speakerImage3 from "../Images/144160____Patton,_Isaac_U_(1).png"

function DeafCampPage2() {
   return(
      <div className="deafCampPage2Content">
         <div className="deafCampPage2Container">
            <div className="deafCampPage2Title">
                  2023 Deaf Camp Speakers
            </div>
            <div className="deafCampPage2SpeakerPictures">
               <div className="deafPictureAndText1">
                  <div className='speakerPicture1'>
                     <img className="deafPic1" src={speakerImage1} alt="SpeakerImage1"></img>
                  </div>
                  <div className="speakerName1">
                     Week 1 <br></br>
                     Levi Stump
                  </div>
               </div>

               <div className="deafLineContainer">
                  <div className="famvl"></div>
               </div>
               
               <div className="deafPictureAndText2">
                  <div className='speakerPicture2'>
                     < img className="deafPic2" src={speakerImage2} alt="SpeakerImage2"></img>
                  </div>
                  <div className="speakerName2">
                     Week 2 <br></br>
                     Grant Stump
                  </div>
               </div>

               <div className="deafLineContainer">
                  <div className="famvl"></div>
               </div>

               <div className="deafPictureAndText3">
                  <div className='speakerPicture2'>
                     < img className="deafPic2" src={speakerImage3} alt="SpeakerImage2"></img>
                  </div>
                  <div className="speakerName2">
                     Week 2 <br></br>
                     Isaac Patton
                  </div>
               </div>

            </div>
         </div>
      </div>
   )
}
export default DeafCampPage2;